import React from "react";

const FooterReleaseInfo = () => (
  <small>ReversingLabs Spectra Assure v{APP_VERSION}</small>
);

export default FooterReleaseInfo;
